import { AppPage } from 'src/Types/AppPage'

export const isBranchDeployed = (pathName: string): boolean => {
  let pathname = pathName.toLowerCase()
  if (!pathname.startsWith('/')) {
    pathname = `/${pathname}`
  }
  return !Object.values(AppPage).some(validAppPagePath => pathname === `/${validAppPagePath.toLowerCase()}`)
}
